var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23.5 23.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.75 3.05 4.66-2.55 1.49 5.1 5.1 1.49-2.55 4.66 2.55 4.66-5.1 1.49-1.49 5.1-4.66-2.55-4.66 2.55-1.49-5.1-5.1-1.49 2.55-4.66-2.55-4.66 5.1-1.49 1.49-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.53 10.86c.55.56 1.44.56 1.99.02.56-.55.56-1.44.02-1.99 0 0-.01-.01-.02-.02-.56-.55-1.45-.54-1.99.02-.54.55-.54 1.43 0 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.96 14.62c.55.56 1.44.56 1.99.02.56-.55.56-1.44.02-1.99 0 0-.01-.01-.02-.02-.56-.55-1.45-.54-1.99.02-.54.55-.54 1.43 0 1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.87 15.14 3.76-6.78"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/Offer.2a9650b27275544e48eb8109678f8d6c.svg";
export { ForwardRef as ReactComponent };